import React from "react";
import "./Styles/recProCard.css"
import { priceFr } from "../Services/Numbers";
import StarIcon from '@mui/icons-material/Star';

export default function RecProCard({ product = {} }) {
  const productsURL = process.env.REACT_APP_API_BASE_URL + '/images/products/';

  const goToProduct = (slug) => {
    window.location.href = "/boutique/"+slug;
  }

  let prices = '';
  if (product.discount) {
    let oldPrice = product.price;
    let newPrice = oldPrice - Math.round(oldPrice * product.discount / 100)
    prices = (<>
        <h3>{priceFr(newPrice)} F <br /><span>{priceFr(oldPrice)} F</span></h3>
    </>)
  }
  else {
    prices = (<>
      <h3>{priceFr(product.price)} F</h3>
    </>)
  }

  let stars = [];
  for (let i = 0; i < product.stars; i++) {
    stars.push(<StarIcon key={'full-star_' + product.slug + '_' + (i + 1)} sx={{ color: 'gold', fontSize: '20px' }} />);
  }

  return (
    <div onClick={()=>{goToProduct(product.slug)}} className="recpro-card-container">
        <div className="recpro-card-img">
            <img src={productsURL+product.thumb} alt={product.thumb}/>
        </div>
        <div className="recpro-card-content">
            <h4>{product.name}</h4>
            <p>{stars}</p>
            {prices}
        </div>
    </div>
  );
}